import type { Graphics } from 'pixi.js';

export type FOSPointColorMode = 'outcome' | 'cluster' | 'product';

export interface FOSPointColorInput {
  outcome?: string | null;
  cluster_id?: number | null;
}

type DiamondGraphics = Pick<
  Graphics,
  'beginFill' | 'moveTo' | 'lineTo' | 'closePath' | 'endFill'
>;

// GO Brand color schemes - semantic colors for regulatory meaning
// Berry -> Upheld (risk to firm - complaint was justified)
// Teal -> Not Upheld (favorable - firm was right)
// Purple -> Partially Upheld (mixed outcome - needs review)
export const OUTCOME_COLORS: Record<string, number> = {
  upheld: 0x92204D,
  not_upheld: 0x07A0C3,
  partially_upheld: 0x924EFF,
};

// Cluster colors using GO brand palette
export const CLUSTER_COLORS = [
  0x0003AE,
  0x924EFF,
  0x07A0C3,
  0x92204D,
  0xFFA9E7,
  0x80D5FF,
  0x500091,
  0x4342FF,
  0xF59E0B,
  0x64748b,
];

export function getFOSPointColor(
  point: FOSPointColorInput,
  colorBy: FOSPointColorMode
): number {
  if (colorBy === 'outcome') {
    return OUTCOME_COLORS[point.outcome || 'not_upheld'] || OUTCOME_COLORS.not_upheld;
  }

  if (colorBy === 'cluster') {
    if (point.cluster_id === null || point.cluster_id === undefined || point.cluster_id < 0) {
      return 0x9ca3af;
    }
    return CLUSTER_COLORS[point.cluster_id % CLUSTER_COLORS.length];
  }

  return 0x6b7280;
}

export function drawDiamond(
  graphics: DiamondGraphics,
  x: number,
  y: number,
  size: number,
  color: number,
  alpha: number
): void {
  const half = size / 2;
  graphics.beginFill(color, alpha);
  graphics.moveTo(x, y - half);
  graphics.lineTo(x + half, y);
  graphics.lineTo(x, y + half);
  graphics.lineTo(x - half, y);
  graphics.closePath();
  graphics.endFill();
}
